var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVivanetWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1491.5,
    height: 438,
    viewBox: "0 0 1491.5 438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Vivanet_White_Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1491.5,
    height: 438
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vivanet_White_Logo",
    "data-name": "Vivanet_White Logo",
    clipPath: "url(#clip-Vivanet_White_Logo)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 1492,
    height: 441,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(-132.2 -972.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M-2425.021-669.081l14.66,16.492s17.561,20.462,35.58,3.359,20.31-21.989,20.31-21.989,13.591-16.187-9.315-23.211c-.153-.153-5.583-2.624-25.654-3.665C-2389.136-697.637-2399.214-681.145-2425.021-669.081Z",
    transform: "translate(2656.786 1897.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M-2350.126-688.112s4.276-13.285-15.575-18.019a134.437,134.437,0,0,0-68.606,2.145c-.445,0-14.935,5.464-19.962-3.825-8.093-13.133-15.118-25.96-15.118-25.96s-4.428-10.078,7.482-14.354c-.153-.458,33.9-14.049,74.825-12.369-.153.153,20.615-1.374,51.308,9.315-.458.153,18.019,4.734,14.507,18.324C-2321.418-732.549-2321.277-725.756-2350.126-688.112Z",
    transform: "translate(2660.991 1902.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M-2353.985-766.9a65.088,65.088,0,0,0,15.44-16.053c-.458,0,39.4,4.276,37.26,23.364a19.43,19.43,0,0,1-5.956,13.056S-2307.257-760.341-2353.985-766.9Z",
    transform: "translate(2650.173 1904.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M-2310.331-769.964s32.1-35.543,15-55.483c-16.659-16.456-52.808-23.442-83.394-24.275-.029.029-68.568-4.661-111.2,11.917-.035-.143-13.66,3.961-11.588,16.8-.6.6,6.75,23.226,6.75,23.226s3.772,15.285,17.469,11.911c.4.2,36.393-15.047,115.188-10.62C-2327.534-792.991-2309.972-784.134-2310.331-769.964Z",
    transform: "translate(2663.927 1911)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i378W2uINk",
    transform: "translate(60.697 -65.022)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Enriching_Talent_Partnering_in_Success",
    "data-name": "Enriching Talent, Partnering in Success",
    transform: "translate(640.303 455.022)",
    fill: "#fff",
    fontSize: 72,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    letterSpacing: "0.011em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -665.983,
    y: 0
  }, "Enriching Talent, Partnering in Success"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M-3366.513,9983h62.757l16.667,57.414,18.107-57.414h60.082l-79.218,194Z",
    transform: "translate(3679.902 -9895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M-3366.512,9983h62.747l16.664,57.414L-3269,9983h60.073l-79.206,194Z",
    transform: "translate(3951.237 -9895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M-3050.862,9983h53.946v194h-54.133Z",
    transform: "translate(3551.648 -9895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M-2473.642,10176.032v-128.892s3.163-45.546-34.506-60.381c-.268.373-20.864-10.82-58.045,0,.535.641-37.448,9.214-39.321,60.381.267.8-1.6,128.892-1.6,128.892h54.568v-126.479s2.14-15.807,15.514-13.663c.268,0,8.56-.8,8.827,16.073v124.069Z",
    transform: "translate(3537.566 -9894.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M-2473.642,10175.408v-128.478s1.653-48.723-34.506-60.187c-.268.372-20.621-11.382-58.169-1.128.044-.287-37.2,5.167-39.2,61.314.267.8-1.6,128.478-1.6,128.478h54.568v-50.771h15.514v-47.8h-15.514v-27.5s2.14-15.756,15.514-13.619c.268,0,8.56-.8,8.827,16.021v123.671Z",
    transform: "translate(3374.054 -9893.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M-1900.028,10174.921l-.057-54.224h-41.152s-9.253.73-10.714-6.34c0-.244-2.8-11.949,9.5-12.07.243.242,39.326,0,39.326,0V10055.4h-35.065s-9.618.3-10.593-9.084c.244.122-1.7-9.876,12.054-9.631-.122.365,36.647,0,36.647,0V9981h-48.7s-53.571-.887-55.154,56.54c-.03-.187-.151,83.157-.151,83.157s-.665,51.36,54.281,54.224C-1949.688,10175.1-1900.028,10174.921-1900.028,10174.921Z",
    transform: "translate(3098.05 -9892.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M-1732.411,10034.174h-41.381V9981h135.269v53.174h-39.642V10175h-54.247Z",
    transform: "translate(3001.641 -9893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TM",
    transform: "translate(1395.541 76)",
    fill: "#fff",
    fontSize: 43,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TM")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivanetWhiteLogo);
export default __webpack_public_path__ + "static/media/Vivanet_White Logo.b0f455a428af333a329701eed0bd0c35.svg";
export { ForwardRef as ReactComponent };